import React, { PropsWithChildren } from 'react';

const AdaptableTitleTagContainer = (props: PropsWithChildren<{className ?: string, href?: string}>): JSX.Element => {
    if (props.href) {
        return (<a className={props.className} href={props.href}>
            {props.children}
        </a>);
    } 
    return (<span className={props.className}>
        {props.children}
    </span>);
    
};

export default AdaptableTitleTagContainer;